var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-wrapper",
    {
      attrs: {
        title: _vm.title,
        subtitle: _vm.calendarName,
        "max-width": _vm.maxWidth,
        deletable: _vm.event.ID != 0,
      },
      on: {
        cancel: function ($event) {
          return _vm.cancel()
        },
        save: function ($event) {
          return _vm.save()
        },
        delete: function ($event) {
          return _vm.deleteEvent()
        },
      },
    },
    [_c("app-calendar-event-edit", { attrs: { event: _vm.event } })],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }